export enum AwsRegions {
  AFS1 = 'af-south-1',
  APE1 = 'ap-east-1',
  APNE1 = 'ap-northeast-1',
  APNE2 = 'ap-northeast-2',
  APS1 = 'ap-south-1',
  APSE1 = 'ap-southeast-1',
  APSE2 = 'ap-southeast-2',
  CAC1 = 'ca-central-1',
  CN1 = 'cn-north-1',
  EUC1 = 'eu-central-1',
  EUN1 = 'eu-north-1',
  EUS1 = 'eu-south-1',
  EUW1 = 'eu-west-1',
  EUW2 = 'eu-west-2',
  EUW3 = 'eu-west-3',
  SAE1 = 'sa-east-1',
  USE1 = 'us-east-1',
  USE2 = 'us-east-2',
  USGE1 = 'us-gov-east-1',
  USGW1 = 'us-gov-west-1',
  USW1 = 'us-west-1',
  USW2 = 'us-west-2',
}

export enum AwsShortRegions {
  AFS1 = 'afs1',
  APE1 = 'ape1',
  APNE1 = 'apne1',
  APNE2 = 'apne2',
  APS1 = 'aps1',
  APSE1 = 'apse1',
  APSE2 = 'apse2',
  CAC1 = 'cac1',
  CN1 = 'cn1',
  EUC1 = 'euc1',
  EUN1 = 'eun1',
  EUS1 = 'eus1',
  EUW1 = 'euw1',
  EUW2 = 'euw2',
  EUW3 = 'euw3',
  SAE1 = 'sae1',
  USE1 = 'use1',
  USE2 = 'use2',
  USGE1 = 'usge1',
  USGW1 = 'usgw1',
  USW1 = 'usw1',
  USW2 = 'usw2',
}

export const AWS_REGIONS_MAP = {
  [AwsShortRegions.AFS1]: AwsRegions.AFS1,
  [AwsShortRegions.APE1]: AwsRegions.APE1,
  [AwsShortRegions.APNE1]: AwsRegions.APNE1,
  [AwsShortRegions.APNE2]: AwsRegions.APNE2,
  [AwsShortRegions.APS1]: AwsRegions.APS1,
  [AwsShortRegions.APSE1]: AwsRegions.APSE1,
  [AwsShortRegions.APSE2]: AwsRegions.APSE2,
  [AwsShortRegions.CAC1]: AwsRegions.CAC1,
  [AwsShortRegions.CN1]: AwsRegions.CN1,
  [AwsShortRegions.EUC1]: AwsRegions.EUC1,
  [AwsShortRegions.EUN1]: AwsRegions.EUN1,
  [AwsShortRegions.EUS1]: AwsRegions.EUS1,
  [AwsShortRegions.EUW1]: AwsRegions.EUW1,
  [AwsShortRegions.EUW2]: AwsRegions.EUW2,
  [AwsShortRegions.EUW3]: AwsRegions.EUW3,
  [AwsShortRegions.SAE1]: AwsRegions.SAE1,
  [AwsShortRegions.USE1]: AwsRegions.USE1,
  [AwsShortRegions.USE2]: AwsRegions.USE2,
  [AwsShortRegions.USGE1]: AwsRegions.USGE1,
  [AwsShortRegions.USGW1]: AwsRegions.USGW1,
  [AwsShortRegions.USW1]: AwsRegions.USW1,
  [AwsShortRegions.USW2]: AwsRegions.USW2,
};

export * from './generated/aws-region';
